import USER_ROLES from '../../constants/user-roles'
import { get } from 'lodash'

const isTsc = (user) => (get(user, 'rolesCode', '') || '').includes(USER_ROLES.TSC)

export default isTsc